import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "top-bar"
}
const _hoisted_3 = { class: "top-save" }
const _hoisted_4 = { class: "save-btn-inner" }
const _hoisted_5 = {
  key: 0,
  class: "save-pulse"
}
const _hoisted_6 = {
  key: 1,
  class: "save-check"
}
const _hoisted_7 = { class: "modal-input" }
const _hoisted_8 = { class: "modal-amount" }
const _hoisted_9 = { class: "amount-info" }
const _hoisted_10 = { class: "amount-label" }
const _hoisted_11 = { class: "amount-credit" }
const _hoisted_12 = { class: "amount-input-row" }
const _hoisted_13 = { class: "main-content" }
const _hoisted_14 = { class: "bottom-nav" }
const _hoisted_15 = {
  key: 1,
  class: "loading-container"
}

import virtual_blacklist from "@/ts/dbvo/virtual_blacklist";
import SignalRClient from "@/ts/SignalRClient";
import Tools from "@/ts/Tools";
import KillPigConfigVO from "@/ts/VO/KillPigConfigVO";
import OutPutStopService from "@/ts/VO/OutPutStopService";
import RoomVO from "@/ts/VO/RoomVO";
import { setRoomNameMap } from "@/ts/roomNameStore";
import AuthManage from "@/views/AuthManage.vue";
import KillPigControl from "@/views/KillPigControl.vue";
// import Overview from "@/views/Overview.vue";
import AccountList from "@/views/AccountList.vue";
import LineConfigManage from "@/views/LineConfigManage.vue";
import {
  createDiscreteApi,
  NButton,
  NInput,
  NInputNumber,
  NPopconfirm,
  NTabs,
  NTabPane,
} from "naive-ui";
import { ref, watch, onUnmounted, computed } from "vue";
import { useRoute } from "vue-router";

type OutPutGetAllBlockList = {
  flag: boolean;
  errorMessage: string;
  list: virtual_blacklist[];
};

type OutPutMessage = {
  flag: boolean;
  errorMessage: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const route = useRoute();
const api = createDiscreteApi(["message"]);

const show_add_black_box = ref(false);
/**
 * 是否显示收益框
 */
const show_amount_box = ref<boolean>(false);
const set_amount = ref<number>();
const dealer_name = ref<string>();

//#region 受控房间

const roomList = ref<RoomVO[]>([]);
const userList = ref<any[]>([]);
const blockList = ref<virtual_blacklist[]>([]);

const selectUser = ref<any>({});

const selectRooms = ref<(string | number)[]>([]);
const killPigEnabled = ref(false);
const isReady = ref(false);
const loadError = ref(false);

// 分页和搜索
const searchKeyword = ref('');
const currentPage = ref(1);
const pageSize = ref(10);
const sortBy = ref('id');
const totalCount = ref(0);
const totalPages = ref(1);

// 刷新收益
const refreshingUser = ref<string | null>(null);
const refreshingAll = ref(false);

// 底部导航
const activeTab = ref((route.query.tab as string) || 'control');

//#endregion

const input = ref<KillPigConfigVO>(new KillPigConfigVO());

// 未保存变更检测：以“保存按钮实际持久化的数据”（配置 input + 房间勾选 selectRooms）为基线，
// 与当前编辑态做深比较。服务端推送（applyRoomList）或初始加载后需重置基线，避免误报。
// RealServerBalance 为实时展示字段（不编辑、不随保存变化），比较时剔除，否则会误判为已改动。
const savedInputSnapshot = ref<string>('');
const savedRoomsSnapshot = ref<string>('');
const isDirty = computed(() => {
  if (!savedInputSnapshot.value) return false; // 尚未建立基线（加载中）
  const curInput = snapshotInputConfig();
  const curRooms = JSON.stringify([...selectRooms.value].sort());
  return curInput !== savedInputSnapshot.value || curRooms !== savedRoomsSnapshot.value;
});
function snapshotInputConfig(): string {
  const clone: Record<string, unknown> = { ...(input.value as any) };
  delete (clone as any).RealServerBalance;
  return JSON.stringify(clone);
}
function baselineSavedState() {
  savedInputSnapshot.value = snapshotInputConfig();
  savedRoomsSnapshot.value = JSON.stringify([...selectRooms.value].sort());
}

// 真实服务器账号余额：独立轮询刷新（只更新展示值，不覆盖用户未保存的配置编辑）
const realBalance = ref<number>(0);
let balanceTimer: number | null = null;

async function RefreshRealBalance() {
  try {
    const cfg = await SignalRClient.Instance.InvokeAsync<KillPigConfigVO>("GetKillPigConfig");
    if (cfg?.RealServerBalance != null) realBalance.value = cfg.RealServerBalance;
  } catch {
    /* 静默失败，下一轮再试 */
  }
}

function StartBalancePolling() {
  RefreshRealBalance();
  balanceTimer = window.setInterval(RefreshRealBalance, 5000);
}

function StopBalancePolling() {
  if (balanceTimer != null) {
    window.clearInterval(balanceTimer);
    balanceTimer = null;
  }
}

onUnmounted(StopBalancePolling);

// 订阅服务端推送的实时余额（下注成功/结算/登录时推送），比轮询更及时
SignalRClient.Instance.AddEventListener("onBalanceUpdate", (b: any) => {
  const v = typeof b === "number" ? b : Number(b);
  if (!isNaN(v)) realBalance.value = v;
});
onUnmounted(() => SignalRClient.Instance.RemoveEventListener("onBalanceUpdate"));

// 服务端房间列表变化（拉取数据 关<->开 重建/销毁房间）时实时推送，无需刷新页面即可更新房间列表与杀猪勾选
SignalRClient.Instance.AddEventListener("onRoomListUpdate", (respRoomObj: { [key: string]: RoomVO }) => {
  applyRoomList(respRoomObj);
});
onUnmounted(() => SignalRClient.Instance.RemoveEventListener("onRoomListUpdate"));

// 服务端推送的账号状态（在线 / 上线时间 / 最后离线时间 / 所在房间），实时更新列表展示
SignalRClient.Instance.AddEventListener("onUserStatusUpdate", (data: any) => {
  const name = data?.userName;
  if (!name) return;
  const u = userList.value.find((x: any) => x.userName === name);
  if (!u) return;
  u.online = !!data.online;
  u.onlineTime = data.onlineTime;
  u.lastOfflineTime = data.lastOfflineTime;
  u.room = data.room;
});
onUnmounted(() => SignalRClient.Instance.RemoveEventListener("onUserStatusUpdate"));

async function InitAsync() {
  try {
    // 等待配置和房间列表加载完成（连接超时由 SignalRClient 内部 10 秒兜底）
    await Promise.all([
      SignalRClient.Instance.InvokeAsync<KillPigConfigVO>("GetKillPigConfig").then(x => { input.value = x; }),
      (async () => {
        var respRoomObj = await SignalRClient.Instance.InvokeAsync<{ [key: string]: RoomVO }>("GetRoomList");
        for (const key in respRoomObj) {
          const room = respRoomObj[key];
          Object.setPrototypeOf(room, RoomVO.prototype);
          if (room.OpenKillPig) {
            selectRooms.value?.push(room.RoomNumber);
          }
          roomList.value.push(room);
        }
        setRoomNameMap(roomList.value);
      })(),
    ]);
    killPigEnabled.value = selectRooms.value.length > 0;
    baselineSavedState(); // 加载完成即建立“已保存”基线
  } catch (e) {
    console.error('初始化失败:', e);
    loadError.value = true;
  } finally {
    isReady.value = true;
  }

  // 后台加载，不阻塞显示
  GetUserListAsync();
  GetAllBlockListAsync();

  // 启动真实账号余额轮询（每 5 秒），不影响配置编辑
  StartBalancePolling();
}

function retryInit() {
  loadError.value = false;
  isReady.value = false;
  InitAsync();
}

// 服务端推送的房间列表实时覆盖本地：保留仍存在的房间的本地勾选（未保存也不丢），并补入服务端已开启的房间
function applyRoomList(respRoomObj: { [key: string]: RoomVO }) {
  const newList: RoomVO[] = [];
  for (const key in respRoomObj) {
    const room = respRoomObj[key];
    Object.setPrototypeOf(room, RoomVO.prototype);
    newList.push(room);
  }
  roomList.value = newList;
  setRoomNameMap(newList);
  const existing = new Set(newList.map(r => r.RoomNumber));
  const keep = (selectRooms.value ?? []).filter((rn: any) => existing.has(rn));
  const serverOn = newList.filter(r => r.OpenKillPig).map(r => r.RoomNumber!);
  selectRooms.value = Array.from(new Set<(string | number)>([...(keep as (string | number)[]), ...serverOn]));
  killPigEnabled.value = selectRooms.value.length > 0;
  baselineSavedState(); // 服务端推送代表权威状态，重置基线避免误报未保存
}

/**
 * 获取用户列表（含统计信息）
 */
async function GetUserListAsync() {
  Tools.FetchGetAsync<{
    allcount: number;
    pagecount: number;
    data: any;
  }>("Game/GetAccountStatsList", {
    page: currentPage.value,
    pageSize: pageSize.value,
    sortBy: sortBy.value,
    userName: searchKeyword.value || undefined,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      userList.value = resp.Data?.data || [];
      totalCount.value = resp.Data?.allcount || 0;
      totalPages.value = resp.Data?.pagecount || 1;
    }
  });
}

/**
 * 获取黑名单列表
 */
async function GetAllBlockListAsync() {
  var blockListItem =
    await SignalRClient.Instance.InvokeAsync<OutPutGetAllBlockList>(
      "GetAllBlockList"
    );
  if (blockListItem.flag) {
    blockList.value = blockListItem.list;
  }
}

/**
 * 添加黑名单
 */
function AddBlackList() {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>(
    "AddBlockList",
    dealer_name.value
  ).then((resp) => {
    if (!resp.flag) {
      Tools.AlertError(resp.errorMessage);
    } else {
      Tools.AlertSuccess("添加成功!");
      GetAllBlockListAsync();
    }
  });
}

/**
 * 删除黑名单
 */
function DeleteBlack(id: number) {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>(
    "RemoveBlockFromID",
    id
  ).then((resp) => {
    if (!resp.flag) {
      Tools.AlertError(resp.errorMessage);
    } else {
      Tools.AlertSuccess("删除成功!");
      GetAllBlockListAsync();
    }
  });
}

/**
 * 尝试添加黑名单
 */
function TryAddBlockList() {
  dealer_name.value = "";
  show_add_black_box.value = true;
}

// 开关联动 selectRooms
watch(killPigEnabled, (enabled) => {
  if (enabled) {
    selectRooms.value = roomList.value.map(r => r.RoomNumber);
  } else {
    selectRooms.value = [];
  }
});

function CancelBlack() {
  show_add_black_box.value = false;
}

/**
 * 充值服务
 */
function RestartService() {
  SignalRClient.Instance.InvokeAsync<OutPutStopService>("RestartService").then(
    (x) => {
      if (x.Ok) {
        Tools.AlertSuccess("重启服务命令已成功发送,等待10秒后，重新尝试登录!");
      }
      else {
        Tools.AlertError(x.ErrorMessage);
      }
    }
  );
}

/**
 * 保存服务配置
 * @param config
 */
async function SetKillPigConfig() {
  // 注意调用顺序：必须先 SetKillPig（落地房间杀猪最终状态），再 SetKillPigConfig（保存总配置）。
  // ChatHub.SetKillPigConfig 内部会按“任意房间 OpenKillPig”强制把拉取数据改回开启；
  // 若先存配置、后清房间，强制判断会看到尚未清掉的旧 OpenKillPig=true，导致“三个同时关”时
  // 拉取数据被错误地重新开启（关不掉）。先清房间再保存配置即可正确关闭。
  const killPigOk = await SignalRClient.Instance.InvokeAsync<boolean>(
    "SetKillPig",
    selectRooms.value
  );
  const configOk = await SignalRClient.Instance.InvokeAsync<boolean>(
    "SetKillPigConfig",
    input.value
  );

  if (configOk && killPigOk) {
    // 重新拉取最新配置：服务端在“杀猪/保持链接”开启时会强制把拉取数据改回开启，
    // 必须把纠正后的状态同步回前端，否则本地仍停在用户关闭时的旧值。
    try {
      const latest = await SignalRClient.Instance.InvokeAsync<KillPigConfigVO>("GetKillPigConfig");
      if (latest) input.value = latest;
    } catch {
      /* 拉取失败不影响本次保存结果，下一轮刷新会补齐 */
    }

    // 同步本地房间“杀猪”状态：SetKillPig 已按 selectRooms 更新服务端 OpenKillPig，
    // 这里把本地 roomList.OpenKillPig 一并对齐，确保“拉取数据”锁（杀猪开启时）正确生效。
    const selected = new Set(selectRooms.value ?? []);
    for (const room of roomList.value) {
      room.OpenKillPig = selected.has(room.RoomNumber);
    }

    baselineSavedState(); // 保存成功后重置基线，清除“未保存”标记
    api.message.success("设置成功!");
  } else {
    api.message.error("设置失败!");
  }
}

/**
 * 显示设置金额
 * @param v
 */
function ShowSetAmount(v: any) {
  selectUser.value = v;
  //显示窗口
  set_amount.value = undefined;
  show_amount_box.value = true;
}

/**
 * 确认充值
 */
function SubmitSetAmount() {
  Tools.FetchGetAsync("Game/SetUserAmountFromUserName", {
    userName: selectUser.value.userName,
    amount: set_amount.value,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess("设置成功!");
      GetUserListAsync();
    }
  });
}

/**
 * 刷新单个用户（收益 + 直播统计）
 */
function refreshUserBalance(user: any) {
  refreshingUser.value = user.userName;
  Tools.FetchGetAsync<{
    userName: string;
    credit: number;
    betCount: number;
    totalBetAmount: number;
    totalWinAmount: number;
    totalEffectiveAmount: number;
  }>("Game/RefreshUserBalance", {
    userName: user.userName,
  }).then((resp) => {
    if (resp.CheckIsOk() && resp.Data) {
      const index = userList.value.findIndex(u => u.userName === user.userName);
      if (index !== -1) {
        userList.value[index].credit = resp.Data.credit;
        userList.value[index].betCount = resp.Data.betCount;
        userList.value[index].totalBetAmount = resp.Data.totalBetAmount;
        userList.value[index].totalWinAmount = resp.Data.totalWinAmount;
        userList.value[index].totalEffectiveAmount = resp.Data.totalEffectiveAmount;
      }
      Tools.AlertSuccess(`${user.userName} 已刷新`);
    }
    refreshingUser.value = null;
  }).catch(() => {
    refreshingUser.value = null;
  });
}

/**
 * 刷新全部用户（收益 + 直播统计）
 */
function refreshAllBalances() {
  if (userList.value.length === 0) {
    Tools.AlertError("当前列表为空");
    return;
  }
  refreshingAll.value = true;
  const userNames = userList.value.map(u => u.userName).join(',');
  Tools.FetchGetAsync<Array<{
    userName: string;
    credit: number;
    betCount: number;
    totalBetAmount: number;
    totalWinAmount: number;
    totalEffectiveAmount: number;
  }>>("Game/RefreshAllUserBalance", {
    userNames: userNames,
  }).then((resp) => {
    if (resp.CheckIsOk() && resp.Data) {
      resp.Data.forEach(item => {
        const index = userList.value.findIndex(u => u.userName === item.userName);
        if (index !== -1) {
          userList.value[index].credit = item.credit;
          userList.value[index].betCount = item.betCount;
          userList.value[index].totalBetAmount = item.totalBetAmount;
          userList.value[index].totalWinAmount = item.totalWinAmount;
          userList.value[index].totalEffectiveAmount = item.totalEffectiveAmount;
        }
      });
      Tools.AlertSuccess("全部已刷新");
    }
    refreshingAll.value = false;
  }).catch(() => {
    refreshingAll.value = false;
  });
}

/**
 * 取消
 */
function CancelSetAmount() { }

/**
 * 清空账号收益
 */
function ClearUserAmount() {
  const currentCredit = selectUser.value.credit ?? 0;
  Tools.FetchGetAsync("Game/SetUserAmountFromUserName", {
    userName: selectUser.value.userName,
    amount: -currentCredit,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess(`已将 ${selectUser.value.userName} 收益清零!`);
      GetUserListAsync();
      show_amount_box.value = false;
    }
  });
}

/**
 * 搜索
 */
function handleSearch() {
  currentPage.value = 1;
  GetUserListAsync();
}

/**
 * 排序切换
 */
function onSortChange(val: string) {
  sortBy.value = val;
  currentPage.value = 1;
  GetUserListAsync();
}

/**
 * 分页切换
 */
function handlePageChange(page: number) {
  currentPage.value = page;
  GetUserListAsync();
}

/**
 * 清空交易数据（该时间之前的记录不统计）
 */
function handleClearBetCache() {
  Tools.FetchGetAsync<any>("Game/SetBetClearCache", {}).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess(`清空交易成功! 时间: ${resp.Data?.time_text || ''}`);
      currentPage.value = 1;
      GetUserListAsync();
    }
  });
}

/**
 * 清空账号显示（该时间之前没有交易记录的账号不显示）
 */
function handleClearAccountCache() {
  Tools.FetchGetAsync<any>("Game/SetAccountClearCache", {}).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess(`清空账号成功! 时间: ${resp.Data?.time_text || ''}`);
      currentPage.value = 1;
      GetUserListAsync();
    }
  });
}

/**
 * 切换账号不清空标记
 */
function handleToggleNoClear(user: any) {
  const newVal = user.noClear ? 0 : 1;
  Tools.FetchGetAsync<any>("Game/SetUserNoClear", {
    userName: user.userName,
    noClear: newVal,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      user.noClear = newVal === 1;
      GetUserListAsync();
    }
  });
}

InitAsync();

return (_ctx: any,_cache: any) => {
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isReady.value && !loadError.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (activeTab.value === 'control')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(NPopconfirm), { onPositiveClick: RestartService }, {
                  trigger: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("div", { class: "top-icon" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
                        _createElementVNode("path", { d: "M3 3v5h5" }),
                        _createElementVNode("path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" }),
                        _createElementVNode("path", { d: "M16 21h5v-5" })
                      ])
                    ], -1)
                  ])),
                  default: _withCtx(() => [
                    _cache[14] || (_cache[14] = _createTextVNode(" 重启后需等待10秒再尝试登录 "))
                  ]),
                  _: 1
                }),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "top-bar-title" }, "数据面板", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(NButton), {
                    size: "small",
                    type: isDirty.value ? 'primary' : 'success',
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (SetKillPigConfig()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, [
                        (isDirty.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                          : (_openBlock(), _createElementBlock("span", _hoisted_6, "✓")),
                        _createTextVNode(" " + _toDisplayString(isDirty.value ? '保存设置' : '已保存'), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["type"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_n_modal, {
            show: show_add_black_box.value,
            "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show_add_black_box).value = $event)),
            preset: "dialog",
            title: "添加主播",
            "positive-text": "确认",
            "negative-text": "取消",
            onPositiveClick: AddBlackList,
            onNegativeClick: CancelBlack
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(NInput), {
                  value: dealer_name.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dealer_name).value = $event)),
                  placeholder: "请输入主播名称",
                  size: "large"
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_n_modal, {
            show: show_amount_box.value,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((show_amount_box).value = $event)),
            preset: "dialog",
            title: "设置收益",
            "positive-text": "确认",
            "negative-text": "取消",
            onPositiveClick: SubmitSetAmount,
            onNegativeClick: CancelSetAmount
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(selectUser.value.userName), 1),
                  _createElementVNode("span", _hoisted_11, "收益: " + _toDisplayString(selectUser.value.credit ?? 0), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(NInputNumber), {
                    value: set_amount.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((set_amount).value = $event)),
                    placeholder: "输入调整额度",
                    size: "large",
                    style: {"flex":"1"}
                  }, null, 8, ["value"]),
                  _createVNode(_unref(NPopconfirm), { onPositiveClick: ClearUserAmount }, {
                    trigger: _withCtx(() => [
                      _createVNode(_unref(NButton), {
                        type: "error",
                        size: "large"
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("清零")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 确定要将 " + _toDisplayString(selectUser.value.userName) + " 的收益清零吗？ ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "amount-tip" }, "输入正数为增加，负数为减少", -1))
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(NTabs), {
              value: activeTab.value,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((activeTab).value = $event)),
              type: "line",
              class: "main-tabs"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NTabPane), {
                  name: "control",
                  tab: "服务配置"
                }, {
                  default: _withCtx(() => [
                    _createVNode(KillPigControl, {
                      input: input.value,
                      killPigEnabled: killPigEnabled.value,
                      realBalance: realBalance.value,
                      "onUpdate:killPigEnabled": _cache[5] || (_cache[5] = ($event: any) => (killPigEnabled.value = $event)),
                      selectRooms: selectRooms.value,
                      roomList: roomList.value,
                      blockList: blockList.value,
                      onAddDealer: TryAddBlockList,
                      onDeleteDealer: DeleteBlack,
                      onClearBetCache: handleClearBetCache,
                      onClearAccountCache: handleClearAccountCache
                    }, null, 8, ["input", "killPigEnabled", "realBalance", "selectRooms", "roomList", "blockList"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NTabPane), {
                  name: "auth",
                  tab: "授权管理"
                }, {
                  default: _withCtx(() => [
                    _createVNode(AuthManage)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NTabPane), {
                  name: "recharge",
                  tab: "主播列表"
                }, {
                  default: _withCtx(() => [
                    _createVNode(AccountList, {
                      userList: userList.value,
                      totalCount: totalCount.value,
                      totalPages: totalPages.value,
                      currentPage: currentPage.value,
                      searchKeyword: searchKeyword.value,
                      sortBy: sortBy.value,
                      refreshingUser: refreshingUser.value,
                      refreshingAll: refreshingAll.value,
                      "onUpdate:searchKeyword": _cache[6] || (_cache[6] = ($event: any) => (searchKeyword.value = $event)),
                      "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (currentPage.value = $event)),
                      "onUpdate:sortBy": onSortChange,
                      onSearch: handleSearch,
                      onPageChange: handlePageChange,
                      onRefreshUser: refreshUserBalance,
                      onRefreshAll: refreshAllBalances,
                      onToggleNoClear: handleToggleNoClear,
                      onModifyBalance: ShowSetAmount
                    }, null, 8, ["userList", "totalCount", "totalPages", "currentPage", "searchKeyword", "sortBy", "refreshingUser", "refreshingAll"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NTabPane), {
                  name: "line",
                  tab: "线路管理"
                }, {
                  default: _withCtx(() => [
                    _createVNode(LineConfigManage)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { active: activeTab.value === 'control' }]),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (activeTab.value = 'control'))
            }, _cache[18] || (_cache[18] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "3"
                }),
                _createElementVNode("path", { d: "M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" })
              ], -1),
              _createElementVNode("span", { class: "nav-text" }, "服务配置", -1)
            ]), 2),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { active: activeTab.value === 'auth' }]),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (activeTab.value = 'auth'))
            }, _cache[19] || (_cache[19] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("rect", {
                  width: "18",
                  height: "11",
                  x: "3",
                  y: "11",
                  rx: "2",
                  ry: "2"
                }),
                _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
              ], -1),
              _createElementVNode("span", { class: "nav-text" }, "授权管理", -1)
            ]), 2),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { active: activeTab.value === 'recharge' }]),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (activeTab.value = 'recharge'))
            }, _cache[20] || (_cache[20] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("rect", {
                  width: "20",
                  height: "14",
                  x: "2",
                  y: "5",
                  rx: "2"
                }),
                _createElementVNode("line", {
                  x1: "2",
                  x2: "22",
                  y1: "10",
                  y2: "10"
                })
              ], -1),
              _createElementVNode("span", { class: "nav-text" }, "主播列表", -1)
            ]), 2),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-item", { active: activeTab.value === 'line' }]),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (activeTab.value = 'line'))
            }, _cache[21] || (_cache[21] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "22",
                height: "22",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polyline", { points: "22 12 18 12 15 21 9 3 6 12 2 12" })
              ], -1),
              _createElementVNode("span", { class: "nav-text" }, "线路管理", -1)
            ]), 2)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (!loadError.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "loading-text" }, "加载配置中...", -1))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[25] || (_cache[25] = _createElementVNode("span", {
                  class: "loading-text",
                  style: {"color":"#f87171"}
                }, "服务连接失败", -1)),
                _createVNode(_unref(NButton), {
                  size: "small",
                  onClick: retryInit
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("重试")
                  ])),
                  _: 1
                })
              ], 64))
        ]))
  ]))
}
}

})